import React from "react";
import PropTypes from "prop-types";
import { MathJax } from "better-react-mathjax";
import style from "./style.module.scss";
import { FormattedMessage } from "react-intl";

/**
 * HintArea for the Question footer component;
 */
export function HintArea(props) {
  return (
    <div className={style.hintArea}>
      <h4>
        <FormattedMessage id="Hint" defaultMessage="Hint" description="" />
      </h4>
      <p>
        <MathJax inline dynamic>
          {props.hint}
        </MathJax>
      </p>
    </div>
  );
}

HintArea.propTypes = {
  /**
   * The hint text
   */
  hint: PropTypes.number,
};
